import React from 'react';
import IconWrapper from '../../../IconWrapper';
const BagIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M4.5 4V2.5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2V4H14v11H2V4h2.5Zm1-1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V4h-5V2.5ZM3 5h10v9H3V5Z" })));
export default BagIconSmall;
//# sourceMappingURL=BagIconSmall.js.map